import gql from "graphql-tag";

export const MY_TIMESHEET_GET_REQUESTS_BADGE = gql`
  query getMyTimesheetRequestsBadge($startDate: Date!, $endDate: Date!) {
    getMyTimesheetRequestsBadge(startDate: $startDate, endDate: $endDate)
  }
`;
